import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { forkJoin, Observable, of } from 'rxjs';
import { map, retry, tap } from 'rxjs/operators';

export interface FilterParams {
  start_date?: string;
  end_date?: string;
  status?: string;
  category?: string;
  search?: string;
  page?: number;
  limit?: number;
}

@Injectable({
  providedIn: 'root'
})
export class BulkTopUpService {

  constructor(private http: HttpClient, private miscService: MiscService) { }



  getRecipientsCategories(page: number, limit: number) {
    const merchant_id = this.miscService.getMerchantDetails().merchant_id;
    return this.http.get(
      `${environment.API_URL}/v2/corporatepay/fetch/categories/${merchant_id}?page=${page}&limit=${limit}&type=topup`
    ).pipe(retry(3));
  }
  getRecipientsBTU = (page, limit, category_id) => {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    params = params.append("category_id", category_id);
    params = params.append("type", "topup");
    return this.http.get(`${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-recipient/${this.miscService.getMerchantDetails().merchant_id}`, { params }).pipe(retry(3))
  }

  getStatusRecipientsBTU = (page, limit, reference, status?) => {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    params = params.append("status", status);
    // params = params.append("type", "topup");
    return this.http.get(`${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`, { params }).pipe(retry(3))
  }
  getStatusTransactionsBTU = (page, limit, status) => {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    params = params.append("type", "topup");
    return this.http.get(`${environment.API_URL3}/merchant/transactions/bulk-pay/${status}/${this.miscService.getMerchantDetails().merchant_id}`, { params }).pipe(retry(3))
  }
  getRecipientLogData = (key) => {
    let params = new HttpParams();
    params = params.append("key", key);
    return this.http.get(`${environment.API_URL3}/merchant/transactions/dump`, { params }).pipe(retry(3))
  }
  createRecipientsCategory = (requestBody) => this.http.post(`${environment.API_URL}/corporatepay/recipient/category?type=topup`, requestBody)

  getCountryProviders = (country_code) => this.http.get(`${environment.API_URL}/airtime/${country_code}`).pipe(retry(3))

  getRecipients = () => this.http.get(`${environment.API_URL}/corporatepay/${this.miscService.getMerchantDetails().merchant_id}?type=topup`).pipe(retry(3))

  logRecipientData = (data) => this.http.post(`${environment.API_URL3}/merchant/transactions/dump`, data)

  createRecipient = (requestBody) => this.http.post(`${environment.API_URL}/corporatepay/recipient?type=topup`, requestBody)

  deleteRecipient = (recipientId) => this.http.delete(`${environment.API_URL}/corporatepay/${recipientId}?type=topup`)

  getRecipientsByCategory = (categoryID) => this.http.get(`${environment.API_URL}/corporatepay/${categoryID}/${this.miscService.getMerchantDetails().merchant_id}?type=topup`).pipe(retry(3))

  editRecipient = (requestBody) => this.http.put(`${environment.API_URL}/corporatepay/recipient?type=topup`, requestBody)

  getRecipientBanks = (recipientCountryCode) => {
    if (recipientCountryCode === '044') {
      return of([]);
    } else {
      return this.http.get(`${environment.API_URL}/banks/${recipientCountryCode}`).pipe(retry(3))
    }
  }

  inititateXasBulkTopUp = (payload) => this.http.post(`${environment.API_URL3}/merchant/transactions/bulk-pay?type=topup`, payload)
  payRecipient = (requestBody, schemeCode) => {
    return this.http.post(`${environment.API_URL3}/merchant/transactions/payment?type=topup`, requestBody)

  }

  checkBulkTopUpStatus = (ref, merchantId) => this.http.get(`${environment.API_URL3}/merchant/transactions/check-bulk-pay-status/${ref}/${merchantId}`).pipe(retry(3))

  updateTransactionStatus = (resource, transactionId, paymentId, status) => this.http.put(`${environment.MERCHANT_AUTH_URL}/api/update/${this.miscService.getMerchantDetails().merchant_id}/${transactionId}/${paymentId}/${status}`, resource)

  generateDLCode = (requestBody) => this.http.post(`${environment.ESA_URL}/otp/generate/dynamic-link`, requestBody)

  getTotalAmount = (payload) => this.http.post(`${environment.API_URL3}/merchant/transactions/bulk-pay-amount`, payload)

  getUtilityProviders = (countryCode: string, utilityType: string = 'topup', utilitySubType: string = 'airtime') => {
    let params = new HttpParams();
    params = params.append("utilityType", utilityType);
    params = params.append("utilitySubType", utilitySubType);
    return this.http.get(`${environment.TRANSACTION_URL}/merchant/utility/${countryCode}`, { params }).pipe(retry(3))
  }

  // Report-related methods
  getBulkTopUpReports(filters: FilterParams): Observable<any> {
    const merchant_id = this.miscService.getMerchantDetails().merchant_id;
    let params = new HttpParams();
    params = params.append("type", "airtime");

    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params = params.set(key, filters[key]);
      }
    });

    const url = `${environment.API_URL3}/merchant/transactions/bulk-pay-reports/${merchant_id}`;
    return this.http.get<any>(url, { params }).pipe(retry(3));
  }

  getAllTransactionDetails(
    reference: string,
    limit: number = 100,
    page: number = 1
  ): Observable<any> {

    if (!reference || reference.trim() === '') {
      throw new Error('Reference parameter is required and cannot be empty');
    }
    const successRequest = this.getStatusRecipientsBTU(page, limit, reference, 'success');
    const failedRequest = this.getStatusRecipientsBTU(page, limit, reference, 'failed');
    const pendingRequest = this.getStatusRecipientsBTU(page, limit, reference, 'pending');

    return forkJoin({
      success: successRequest,
      failed: failedRequest,
      pending: pendingRequest
    }).pipe(
      map((responses: any) => {

        const successData = responses.success?.data || { data: [], totalCount: 0 };
        const failedData = responses.failed?.data || { data: [], totalCount: 0 };
        const pendingData = responses.pending?.data || { data: [], totalCount: 0 };

        return {
          successful: {
            transactions: successData.data || [],
            totalCount: successData.totalCount || 0
          },
          failed: {
            transactions: failedData.data || [],
            totalCount: failedData.totalCount || 0
          },
          pending: {
            transactions: pendingData.data || [],
            totalCount: pendingData.totalCount || 0
          },
          summary: {
            successful: successData.totalCount || 0,
            failed: failedData.totalCount || 0,
            pending: pendingData.totalCount || 0,
            total: (successData.totalCount || 0) + (failedData.totalCount || 0) + (pendingData.totalCount || 0)
          }
        };
      }),
      retry(3)
    );
  }

  getTransactionDetailsByStatus(
    reference: string,
    status: 'success' | 'failed' | 'pending',
    limit: number = 100,
    page: number = 1
  ): Observable<{ transactions: any[], totalCount: number, currentPage: number, totalPages: number }> {

    if (!reference || reference.trim() === '') {
      throw new Error('Reference parameter is required and cannot be empty');
    }

    return this.getStatusRecipientsBTU(page, limit, reference, status).pipe(
      map((response: any) => {
        return {
          transactions: response.data?.data || [],
          totalCount: response.data?.totalCount || 0,
          currentPage: response.data?.currentPage || page,
          totalPages: response.data?.totalPages || 1
        };
      })
    );
  }

  downloadFailedRecipientsBTU(reference: string) {
    let params = new HttpParams()
      .set('status', 'failed')
      .set('export', 'true')
    // .set('type', 'topup');

    const url = `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`;

    return this.http.get(url, {
      params,
      responseType: 'blob'
    }).pipe(retry(3));
  }

  downloadSuccessfulRecipientsBTU(reference: string) {
    let params = new HttpParams()
      .set('status', 'success')
      .set('export', 'true')
    // .set('type', 'topup');

    const url = `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`;

    return this.http.get(url, {
      params,
      responseType: 'blob'
    }).pipe(retry(3));
  }

  downloadPendingRecipientsBTU(reference: string) {
    let params = new HttpParams()
      .set('status', 'pending')
      .set('export', 'true')
    // .set('type', 'topup');

    const url = `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`;

    return this.http.get(url, {
      params,
      responseType: 'blob'
    }).pipe(retry(3));
  }

  recreateFailedTransactions(merchantId: string, categoryId: string, sessionId: string, transactionRefs: string[]): Observable<any> {
    return this.http.post(`${environment.API_URL}/corporatepay/create-failed-category/${merchantId}/${categoryId}?type=topup`, {
      session_id: sessionId,
      transaction_ref: transactionRefs
    }).pipe(retry(3));
  }

}
